// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OfertaRouteImport } from './routes/oferta'
import { Route as ObrigadoGrupoRouteImport } from './routes/obrigado-grupo'
import { Route as ObrigadoRouteImport } from './routes/obrigado'
import { Route as MiguelcRouteImport } from './routes/miguelc'
import { Route as InscricaoRouteImport } from './routes/inscricao'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AplicacaoRouteImport } from './routes/aplicacao'
import { Route as AovivoRouteImport } from './routes/aovivo'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'

const OfertaRoute = OfertaRouteImport.update({
            id: '/oferta',path: '/oferta',getParentRoute: () => rootRouteImport
          })
const ObrigadoGrupoRoute = ObrigadoGrupoRouteImport.update({
            id: '/obrigado-grupo',path: '/obrigado-grupo',getParentRoute: () => rootRouteImport
          })
const ObrigadoRoute = ObrigadoRouteImport.update({
            id: '/obrigado',path: '/obrigado',getParentRoute: () => rootRouteImport
          })
const MiguelcRoute = MiguelcRouteImport.update({
            id: '/miguelc',path: '/miguelc',getParentRoute: () => rootRouteImport
          })
const InscricaoRoute = InscricaoRouteImport.update({
            id: '/inscricao',path: '/inscricao',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AplicacaoRoute = AplicacaoRouteImport.update({
            id: '/aplicacao',path: '/aplicacao',getParentRoute: () => rootRouteImport
          })
const AovivoRoute = AovivoRouteImport.update({
            id: '/aovivo',path: '/aovivo',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AovivoRoute: AovivoRoute,AplicacaoRoute: AplicacaoRoute,AuthRoute: AuthRoute,InscricaoRoute: InscricaoRoute,MiguelcRoute: MiguelcRoute,ObrigadoRoute: ObrigadoRoute,ObrigadoGrupoRoute: ObrigadoGrupoRoute,OfertaRoute: OfertaRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)